import { useForm } from 'react-hook-form';
import FilterWrapper from './FilterWrapper';
import StandardFilter from './StandardFilter';
import { closeOptions } from '@utils/utils';

export const TextFilter = ({ filterField, addFilter, ...rest }) => {
    const {
        control,
        formState: { isValid }, // required to rerennder the apply button
        handleSubmit,
        watch,
    } = useForm({
        shouldUnregister: true,
        defaultValues: {
            lookup: filterField?.defaultLookup || filterField.filterOptions[0],
        },
    });
    if (!rest.open) return null;
    const { name } = filterField;

    const onSubmit = data => {
        addFilter(`${name}__${data.lookup}`, data[name]);
        rest.onClose();
        closeOptions();
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FilterWrapper
                title={filterField.label}
                name={name}
                control={control}
                {...rest}
            >
                <StandardFilter
                    filterField={filterField}
                    addFilter={addFilter}
                    control={control}
                />
            </FilterWrapper>
        </form>
    );
};
